import { call, put } from 'redux-saga/effects';

import { takeLatest } from '../../../utils/reduxSaga';
import { actions as sagaActions, GET_SIMCARD } from './types';
import { actions as reduxActions } from '../reducers';
import { getData } from '../../../utils/http';
import { JSONAPI_URLS, URLS } from '../../../consts/endpoints';
import {
  isArray,
  isDefined,
  isObject,
  isUndefined,
  isString
} from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import getSubscriptions from './getSubscription';
import urlCreator from '../../../utils/urlCreator';
import checkIfIsEsimCard from '../../../utils/checkIfIsEsimCard';
import checkIfIsIoT from '../../../utils/checkIfIsIoT';
import findIccFromSub from '../../../utils/findIccFromSub';

export function getSimcard(id, number) {
  return {
    type: sagaActions[GET_SIMCARD],
    id,
    number
  };
}

export function* fetchSimcard({ id, number }) {
  let simcard = {};
  let activationCode = void 0;
  let isESimCard = false;
  let subscription = void 0;
  let isIoTCard = false;

  try {
    if (isDefined(number)) {
      const { data } = yield call(
        getData,
        urlCreator(JSONAPI_URLS.SIM_CARDS, {
          filter: { msisdn: number }
        })
      );

      if (isDefined(data[0])) {
        simcard = data[0];
      } else {
        simcard = {};
      }
    } else {
      const { data } = yield call(
        getData,
        urlCreator(`${URLS.SIM_CARDS}/${id}.json`, {
          include: ['client']
        })
      );

      simcard = data;
    }

    if (isDefined(simcard?.icc) && isDefined(simcard?.client_id)) {
      subscription = yield call(
        getSubscriptions,
        simcard.msisdn,
        simcard.client_id
      );

      let changeIccProblems = [];
      if (
        isDefined(subscription?.problems) &&
        isArray(subscription?.problems)
      ) {
        changeIccProblems = subscription.problems.filter(
          problem =>
            problem.severity === 'MAJOR' &&
            isString(problem?.message) &&
            problem.message.includes('Change icc in progress')
        );
      }
      if (isArray(changeIccProblems) && changeIccProblems.length > 0) {
        simcard.icc = null;
        simcard.pin1 = null;
        simcard.puk1 = null;
      } else {
        const iccFromSub = yield call(
          findIccFromSub,
          subscription,
          simcard.msisdn
        );
        const icc = Optional(iccFromSub).or(simcard.icc);

        simcard.icc = icc;

        const response = yield call(
          getData,
          `${URLS.QUOTE_CLIENTS}/${simcard.client_id}/resources/search?icc=${icc}`
        );

        simcard.pin1 = Optional(response?.pin1).or(simcard.pin1);
        simcard.puk1 = Optional(response?.puk1).or(simcard.puk1);

        activationCode = Optional(response?.activationCode).or(void 0);

        isESimCard = checkIfIsEsimCard(response?.simCardType);

        isIoTCard = checkIfIsIoT(response?.usage_type);
      }
    }
  } finally {
    yield put(
      reduxActions.setSimcard({
        simcard,
        activationCode,
        isESimCard,
        subscription
      })
    );

    if (isIoTCard) {
      yield put(reduxActions.setIsIoT(true));
    }
  }
}

function* watchFetchSimcard() {
  yield takeLatest(sagaActions[GET_SIMCARD], fetchSimcard);
}

export default watchFetchSimcard();
